export const BOUNCEABLE_TON_NATIVE_ADDRESS = 'EQAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAM9c';
export const STONFI_REFERRAL_ADDRESS = 'UQDCgZa4vgbHOIEYrbWTaD5pEmDN0opSfs3gQZ_dYOVzEsx1';
